<div class="navigation-row">
  <div class="org-logo">
    <img *ngIf="organisationIconUrl" class="org-icon" [src]="organisationIconUrl">
  </div>
  <ng-container *ngFor="let module of modules; let i = index">
    <button class="module-button" [ngClass]="{'active': i == 1}" mat-button [matMenuTriggerFor]="menu">
      <div class="button-label">
        {{module.name}}
        <img src="../../../assets/icons/down.svg">
      </div>
    </button>
    <mat-menu #menu="matMenu" [panelClass]="'custom-nav-menu'">
      <div class="menu-grid">
        <ng-container *ngFor="let child of module.children">
          <button mat-menu-item (click)="navigateTo(child.route)">
            <div class="menu-item-name">
              <img [src]="child.iconUrl">
              {{child.name}}
            </div>
          </button>
        </ng-container>
      </div>
    </mat-menu>
  </ng-container>
  <div class="right-section">
    <div class="powered-div">
      <p>powered by</p>
      <img src="../../../assets/icons/ff_new_logo.svg">
    </div>
    <img class="setting-icon" src="../../../assets/icons/settings.svg" alt="">
    <div class="user-profile" (click)="toggleUserDropdown($event)">
      <div class="user-initial">{{ user.name[0] }}</div>
      <div class="user-dropdown" [class.expanded]="showUserDropdown">
        <div class="user-dropdown-content pointer">
          <div class="user-info" *ngIf="user">
            <div class="user-name">{{ user.name }}</div>
            <div class="user-org-name">{{ user.organization.name }}</div>
            <div class="user-email">{{ user.email }}</div>
          </div>
          <!-- <ng-container *ngIf="!userImpresnanionMode"> -->
          <ng-container *ngIf="true">
            <div class="dropdown-divider"></div>
            <div class="logout-option" (click)="logout()">
              <span class="logo">
                <img src="../../../assets/icons/log-out.svg" alt="">
              </span>
              <span>Logout</span>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>